import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Index = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-12 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                  <h1 className="text-center ">404</h1>
                </div>

                <div className="contant_box_404">
                  <Link to="/" className="theme_btn btn btn-primary mt-3">
                    {t("HOME_PAGE")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
